// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3331":"css/admin-app.6933","7298":"css/app.6933"}[chunkId] + ".css";
};